import { decryptedSSN } from "@inrev/common";
import { Option } from "@inrev/core";
import { z } from "zod";

export const uniqueSSNSchema = (ssns: string[]) =>
	decryptedSSN.refine((val) => !ssns.includes(val), { message: "SSN Already Used" });

export const uniqueSchema = <T>(
	values: readonly T[],
	schema: z.ZodType<T | null | undefined>,
	message?: string,
) => {
	const isUnique = (val: T | null | undefined) => {
		if (Option.isNone(val)) return true;
		return !values.includes(val);
	};
	return message === undefined ? schema.refine(isUnique) : schema.refine(isUnique, { message });
};
